"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/util/isFunction.js